export const createUiModalTemplate = (id, options) => {
  const {
    wrapperClass,
    isIndent,
    isCenter,
    isCustom,
    isBottomSheet,
    isCloseButton,
    backgroundTheme = 'default',
    outerScroll
  } = options

  return (
    `<section
      class="
        ui-modal
        ui-modal--${backgroundTheme}
        ${isCustom ? 'ui-modal--custom' : ''}
        ${isBottomSheet ? 'ui-modal--bottom-sheet' : ''}
        ${outerScroll ? 'ui-modal--outer-scroll' : ''}
      "
      id="${id}"
    >
      <div
        class="
          ui-modal__wrapper
          ${wrapperClass || ''}
          ${isCustom ? 'ui-modal__wrapper--custom' : ''}
          ${isBottomSheet ? 'ui-modal__wrapper--bottom-sheet' : ''}
        "
      >
        ${isCloseButton
          ? `<button
              class="
                ui-modal__close
                ui-icon-button
                ui-icon-button--filled-secondary
                ui-icon-button--small
                ui-icon-button--circle
              "
              type="button"
              aria-label="Закрыть модальное окно"
            >
              <svg
                width="20"
                height="20"
                aria-hidden="true"
                class="
                  ui-icon-button__icon
                  ui-icon-button__icon--small
                "
              >
                <use href="#ui-close"/>
              </svg>
            </button>`
          : ''
        }

        <div
          class="
            ui-modal__content
            ${isIndent && !isBottomSheet ? 'ui-modal__content--indent' : ''}
            ${isCustom ? 'ui-modal__content--custom' : ''}
            ${isBottomSheet ? 'ui-modal__content--bottom-sheet' : ''}
          "
        >
          <div
            class="
              ui-modal__scroll
              ${isCenter ? 'ui-modal__scroll--center' : ''}
            "
            data-element="content-wrapper"
          >
          </div>
        </div>
      </div>
    </section>`
  )
}
